import { render, staticRenderFns } from "./timeoutTag.vue?vue&type=template&id=168099ca&scoped=true"
import script from "./timeoutTag.vue?vue&type=script&lang=js"
export * from "./timeoutTag.vue?vue&type=script&lang=js"
import style0 from "./timeoutTag.vue?vue&type=style&index=0&id=168099ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168099ca",
  null
  
)

export default component.exports